import React, {useEffect, useState} from "react";
import * as Yup from "yup";
import ValidateMessages from "../../../../../core/models/static/texts/vallidate-messages";
import useIsMounted from "../../../../hooks/use-is-mounted";
import {makeRequired, makeValidate} from "mui-rff";
import classnames from "classnames";
import Form from "../../../base/form";
import {Fade, SvgIcon} from "@mui/material";
import IconButton from "../../../base/button/icon_button";
import {Edit} from "@mui/icons-material";
import {ReactComponent as RemoveIcon} from "../../../../../assets/images/remove.svg";
import {ReactComponent as HorizontalDragIcon} from "../../../../../assets/images/notifications/horizontal-drag.svg";
import {OutlinedInputForm} from "../../../base/input/outlined_input";
import SaveOrRollback from "../../save-or-rollback";


const schema = Yup.object().shape({
    title: Yup.string().nullable().required(ValidateMessages.required)
});

const NotificationCategoryCard = ({category, update, remove, setEditing, sortable}) => {
    const [initialValues, setInitialValues] = useState({});
    const isMounted = useIsMounted()
    const validate = makeValidate(schema);
    const required = makeRequired(schema);
    const editing = category?.inEditMode;

    /**
     * Listens to the changes in the category and with each change:
     * sets the initialValues of the form.
     */
    useEffect(() => {
        setInitialValues({
            title: category?.title ?? '',
        })
    }, [category])

    /**
     * Prepares the new version of the category to be sent through api and then based on the returned resultFlag,
     * remains in or gets out of the edit mode.
     * @param {mode} values formValues
     */
    const updateCategory = (values) => {
        if (values?.title === category?.title) {
            setEditing(false)
            return
        }
        const newTitle = {
            ...category,
            title: values.title,
        }
        update(newTitle).then(resultFlag => resultFlag && isMounted() && setEditing(false))
    }

    /**
     * Reverts the values of this template.
     * @param {any} values
     * @param {formApi} form
     */
    const revertValues = (values, form) => {
        setEditing(false)
        form.reset(initialValues)
    }

    /**
     * Gets users confirmation before removing the current entity.
     */
    const getRemoveConfirmation = () => {
        window.partner?.openConfirmationDialog(
            <div className={'p-3'}>
                <p className={'text-sm text-color-2'}>
                    Do you want to delete this group? by deleting this group, all of the saved items will be under the default saved group?
                </p>
            </div>,
            {
                maxWidth: 'sm'
            },
            (confirmed) => confirmed && remove(category).then(),
        );
    }

    return (
        <>
            <div className={classnames('category-notification-card', {'editing': editing})}>
                <Form
                    className={''}
                    onSubmit={() => false}
                    validate={validate}
                    initialValues={initialValues}
                    render={({values, form}) => {
                        return (
                            <>
                                <div className={'d-flex flex-column'}>
                                    <div className={classnames('fade-container', {
                                        'expanded': editing,
                                    })}>
                                        <Fade in={editing}
                                              className={'d-flex justify-content-between align-items-center'}>
                                            <div>
                                                <OutlinedInputForm
                                                    name={'title'}
                                                    placeholder={'title'}
                                                    label={"Title"}
                                                    multiline
                                                    className={'mr-2 ml-5 max-w-80'}
                                                    required={required.title}
                                                    value={values.title ?? ''}
                                                    onChange={(e) => form.change(e.target.name, e.target.value)}
                                                />
                                                <SaveOrRollback
                                                    column={false}
                                                    loading={category.editing}
                                                    show={true}
                                                    onRollback={() => revertValues(values, form)}
                                                    onSave={() => updateCategory(values)}
                                                />
                                            </div>
                                        </Fade>
                                        <Fade in={!editing}
                                              className={'d-flex align-items-center justify-content-between'}>
                                            <div>
                                                <p className={'title flex-grow-1'}>
                                                    <Fade in={sortable} className={'mr-3 handle'}>
                                                        <SvgIcon component={HorizontalDragIcon}/>
                                                    </Fade>
                                                    {category?.title ?? ''}
                                                </p>
                                                <div className={'d-flex justify-content-end align-items-center'}>
                                                    <IconButton
                                                        disabled={category.editing || editing}
                                                        className={"mx-1 ml-2"}
                                                        color={'paper.secondary'}
                                                        onPressed={() => setEditing(true)}
                                                    >
                                                        <Edit className={"icon normal"}/>
                                                    </IconButton>
                                                    <IconButton
                                                        onPressed={getRemoveConfirmation}
                                                        disabled={category?.editing}
                                                        color={'paper.error'}
                                                        className={'ml-2'}
                                                    >
                                                        <SvgIcon component={RemoveIcon}
                                                                 className='icon normal'/>
                                                    </IconButton>
                                                </div>
                                            </div>
                                        </Fade>
                                    </div>
                                </div>
                            </>
                        );
                    }}
                />
            </div>
        </>
    );
}

export default NotificationCategoryCard;
